import React, { useState } from 'react';

import { setDialogCardAnalytics } from 'store/analytics';
import { trackPageView } from 'store/analytics/analytics.thunks';
import { useAppDispatch } from 'store/store';

import DialogueCard from './DialogueCard/DialogueCard';
import { useDialogueCard } from './hooks/DialogueCard.hooks';

const DialogueCardPanel: React.FC = () => {
  const dialogueCardData = useDialogueCard();
  const dispatch = useAppDispatch();
  const [pageTracked, setPageTracked] = useState(false);
  if (!dialogueCardData) return null;

  dispatch(setDialogCardAnalytics(dialogueCardData.analyticsId));

  // Should only track page view once
  if (!pageTracked) {
    dispatch(trackPageView('details'));
    setPageTracked(true);
  }

  if (!dialogueCardData.type) return null;
  return <DialogueCard dialogueCard={dialogueCardData} />;
};

export default DialogueCardPanel;
